import { render, staticRenderFns } from "./UploadMaterial.vue?vue&type=template&id=28e3c0fc&scoped=true"
import script from "./UploadMaterial.vue?vue&type=script&lang=js"
export * from "./UploadMaterial.vue?vue&type=script&lang=js"
import style0 from "./UploadMaterial.vue?vue&type=style&index=0&id=28e3c0fc&prod&scoped=true&lang=scss"
import style1 from "./UploadMaterial.vue?vue&type=style&index=1&id=28e3c0fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e3c0fc",
  null
  
)

export default component.exports